import { Outlet } from 'react-router-dom';
import { Box, Container } from 'ui';

import classes from './CausePage.module.css';
import { CauseGuard } from './components/CauseGuard';
import { CausePageHeader } from './components/CausePageHeader/CausePageHeader';
import { CausePageTabs } from './components/CausePageTabs/CausePageTabs';

const CausePageLayout = () => {
  return (
    <CauseGuard>
      <CausePageHeader />
      <Box className={classes.CausePage}>
        <Container size="sm" px={{ base: '0px', sm: 'xs' }}>
          <CausePageTabs />
          <Outlet />
        </Container>
      </Box>
    </CauseGuard>
  );
};

export { CausePageLayout };
